import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
	selector: '[OnlyPositiveIntegers]',
	standalone: false,
})
export class OnlyPositiveIntegersDirective {
	private validKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
	private validIntegers = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
	constructor(private el: ElementRef) {}
	/** Checks for valid decimal input but prevents normal behavior if we detect paste, that will be handled in the paste @HotListener onPaste handler */
	@HostListener('keydown', ['$event']) onKeyDown(event: KeyboardEvent) {
		if (this.validKeys.includes(event.key)) {
			return true;
		}

		const inputVal: string = this.el.nativeElement.value.concat(event.key);

		if (!this.validIntegers.includes(event.key) || inputVal.startsWith('0')) {
			event.preventDefault();
			return false;
		}

		return true;
	}

	@HostListener('paste', ['$event']) onPaste(event) {
		if (event instanceof ClipboardEvent) {
			const clipboardData = event.clipboardData.getData('text/plain');
			if (clipboardData) {
				if (!this.validIntegers.includes(clipboardData) || clipboardData.startsWith('0')) {
					event.preventDefault();
				}
			}
		}
	}
}
